import Skeleton from 'react-loading-skeleton'

export default function SkeletonFilter() {
    return (<>
        <Skeleton height={24} width={140} style={{ marginBottom: 10 }} />
        {Array.from({ length: 3 }).map((_, i) => (
            <div className="custom-filter-group" key={i}>
                <Skeleton height={14} width={100} style={{ marginBottom: 10 }} />
                <Skeleton count={4} height={16} width={120} style={{ marginBottom: 8 }} />
            </div>
        ))}</>
    )
}
